var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRowDeletedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 18.75H2.5C2.16848 18.75 1.85054 18.6183 1.61612 18.3839C1.3817 18.1495 1.25 17.8315 1.25 17.5V13.75C1.25 13.4185 1.3817 13.1005 1.61612 12.8661C1.85054 12.6317 2.16848 12.5 2.5 12.5H15C15.3315 12.5 15.6495 12.6317 15.8839 12.8661C16.1183 13.1005 16.25 13.4185 16.25 13.75V17.5C16.25 17.8315 16.1183 18.1495 15.8839 18.3839C15.6495 18.6183 15.3315 18.75 15 18.75ZM2.5 13.75H2.49875L2.5 17.5H15V13.75H2.5ZM18.75 2.13125L17.8687 1.25L15.625 3.49375L13.3813 1.25L12.5 2.13125L14.7437 4.375L12.5 6.61875L13.3813 7.5L15.625 5.25625L17.8687 7.5L18.75 6.61875L16.5063 4.375L18.75 2.13125Z",
    fill: "black",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 8.75V5H11.25V3.75H2.5C2.16848 3.75 1.85054 3.8817 1.61612 4.11612C1.3817 4.35054 1.25 4.66848 1.25 5V8.75C1.25 9.08152 1.3817 9.39946 1.61612 9.63388C1.85054 9.8683 2.16848 10 2.5 10H16.25V8.75H2.5Z",
    fill: "black",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRowDeletedIcon);
export default __webpack_public_path__ + "static/media/rowDeletedIcon.03a198f778a2b1aa316bfa804612a54b.svg";
export { ForwardRef as ReactComponent };